<div class="modal fade" aria-hidden="true">
    <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    Importar Pedidos do ERP
                </h4>        
            </div>
            <div class="modal-body">
                <form #form="ngForm" novalidate>
                    <ng-template [ngIf]="filter">
                        <div class="row">
                            <div class="form-group col-12">
                                <label for="importModalIntegracao" class="col-form-label">ERP</label>
                                <select class="form-control" name="importModalIntegracao" id="importModalIntegracao" 
                                    [ngModel]="filter.idIntegracao || ''" (ngModelChange)="filter.idIntegracao = $event ? $event : null"
                                    #importModalIntegracao="ngModel" required="required">
                                    <option *ngFor="let integracao of integracoes" [ngValue]="integracao.id">{{integracao.nome}}</option>
                                </select>  
                                <p class="form-text text-muted">ERP que será importado os pedidos</p>
                                <sgt-form-control-error
                                    *ngIf="importModalIntegracao.errors && importModalIntegracao.errors.required && importModalIntegracao.dirty"
                                    msgError="É obrigatório selecionar o ERP que deseja importar os pedidos">
                                </sgt-form-control-error>                                       
                            </div>                        
                        </div> 

                        <div class="row" *ngIf="configEmpresa?.possuiLocalFaturamento">
                            <div class="form-group col-12">
                                <label for="importModalLocalFaturamento" class="col-form-label">Local do Faturamento</label>
                                <sgt-local-faturamento-select
                                    #localFaturamentoSelect
                                    [(ngModel)]="filter.idLocalFaturamento"
                                    (localFaturamentoChange)="onChangeLocalFaturamento($event)"
                                    name="importModalLocalFaturamento" 
                                    id="importModalLocalFaturamento"
                                    #importModalLocalFaturamento="ngModel"
                                    [somenteAtivos]="true">
                                </sgt-local-faturamento-select>
                            </div>
                        </div> 

                        <div class="row">
                            <div class="form-group col-12">
                                <label for="importModalnumeroPedidoIntegracao" class="col-form-label">Número ERP</label>
                                <input type="text" class="form-control" [(ngModel)]="filter.numeroPedidoIntegracao" name="importModalnumeroPedidoIntegracao" id="importModalnumeroPedidoIntegracao"
                                    #importModalnumeroPedidoIntegracao="ngModel">
                                <p class="form-text text-muted">Número do pedido no ERP</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-12 col-md">
                                <label class="col-form-label" for="importModalDataEmissaoInicial">Data Emissão Inicial</label>
                                <sgt-datepicker [(ngModel)]="filter.dataEmissaoInicial" name="importModalDataEmissaoInicial" id="importModalDataEmissaoInicial"
                                    #importModalDataEmissaoInicial="ngModel" #datePickerDataEmissaoInicial [ngControl]="importModalDataEmissaoInicial">
                                </sgt-datepicker>
                                <p class="form-text text-muted">Pedidos emitidos a partir desta data</p>
                            </div> 
                            <div class="form-group col-12 col-md">
                                <label class="col-form-label" for="importModalDataEmissaoFinal">Data Emissão Final</label>
                                <sgt-datepicker [(ngModel)]="filter.dataEmissaoFinal" name="importModalDataEmissaoFinal" id="importModalDataEmissaoFinal"
                                    #importModalDataEmissaoFinal="ngModel" #datePickerDataEmissaoFinal [ngControl]="importModalDataEmissaoFinal">
                                </sgt-datepicker>
                                <p class="form-text text-muted">Pedidos emitidos até esta data</p>
                            </div>                                                     
                        </div>
                    </ng-template>
                </form>
            </div>
            <div class="modal-footer">           
                <button type="button" class="btn btn-light" (click)="close()">
                    Cancelar
                </button>
                <button type="button" class="btn btn-primary" (click)="import()" [disabled]="form.invalid">
                    <i class="fas fa-download"></i> Importar
                </button>                  
            </div>            
        </div>
    </div>
</div>